
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, NgZone } from '@angular/core';
import { ProxyCmp, initOutputs } from '../lib';
import type { JSX, Components } from '@vime/core/dist/types';

import { 
  VmFullscreenControl,
  VmControl,
  VmIcon,
  VmTooltip 
} from '@vime/core';

import { define } from '../lib';
  

const FullscreenControlInputs: string[] = [
  'enterIcon',
  'exitIcon',
  'icons',
  'tooltipPosition',
  'tooltipDirection',
  'hideTooltip',
  'keys',
  'isFullscreenActive',
  'i18n',
  'playbackReady',
];

const FullscreenControlMethods: string[] = [
  
];

const FullscreenControlOutputs: string[] = [
  
];

export type Emitter<T extends ((...args: any[]) => any) | undefined> = EventEmitter<Parameters<Exclude<T, undefined>>[0]>;

export declare interface FullscreenControl extends Components.VmFullscreenControl {}

@ProxyCmp({
  inputs: FullscreenControlInputs,
  methods: FullscreenControlMethods,
})
@Component({
  selector: 'vm-fullscreen-control',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: FullscreenControlInputs,
  outputs: FullscreenControlOutputs,
})
export class FullscreenControl {
  protected el: HTMLElement;

  

  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    define('vm-fullscreen-control', VmFullscreenControl);
    define('vm-control', VmControl);
    define('vm-icon', VmIcon);
    define('vm-tooltip', VmTooltip);
    c.detach();
    this.el = r.nativeElement;
    initOutputs(this, [])
  }
}
  